import { Box, Stack, Typography, Divider } from "@mui/material";
import { useRestaurantData } from "../provider/RestaurantDataContext";
import RestaurantSocialMedia from "./RestaurantSocialMedia";

export default function RestaurantBanner() {
    const { restaurantData } = useRestaurantData();

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '1rem', minWidth: '100%' }}>
            <Stack
                spacing={2}
                sx={{ minWidth: '100%' }}
                direction="column"
                justifyContent="space-around">
                <Typography sx={{ color: 'white', fontWeight: 'bold', textAlign: 'center' }} variant='h5'>
                    {restaurantData.name}
                </Typography>
                <Divider variant="fullWidth" sx={{bgcolor:'white'}} />
                <RestaurantSocialMedia />
            </Stack>
        </Box >
    );
}